import { Button } from "@mui/material";
import { NumberField } from "features/WorklistTools/shared/components/NumberField";
import { PlateType } from "features/WorklistTools/shared/components/PlateType";
import {
  NucleofectionStep,
  PlatePosition,
} from "features/WorklistTools/shared/interfaces";
import styled from "styled-components";
import { NucleofectionPlateInfoState } from "../../state";
import { WashVol } from "./WashVol";

const StyledPlateActions = styled.div`
  width: 100%;
  margin-top: 7px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 10px;
`;

const StyledPlateTypeContainer = styled.div`
  margin-top: 15px;
`;

const StyledButtonDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

interface NucleofectionFooterProps {
  nucPlateInfo: NucleofectionPlateInfoState;
  nucelofectionStep: NucleofectionStep;
  handleUploadPlateClick: (value: number) => void;
  setUploadedNucleofectionPlate: (value: boolean) => void;
  selectedSystem: number;
  nucPlateTypeInfo: any;
  handlePlateTypeChanged: (index: number, plateTypeInfo: any) => void;
  addToNucButtonDisabled: boolean;
  handleAddToNucPlate: () => void;
  handleNumWashesChanged: (plateIndex: number, numWashes: number) => void;
}

export const NucleofectionPlateFooter = ({
  nucPlateInfo,
  nucelofectionStep,
  handleUploadPlateClick,
  setUploadedNucleofectionPlate,
  selectedSystem,
  nucPlateTypeInfo,
  handlePlateTypeChanged,
  addToNucButtonDisabled,
  handleAddToNucPlate,
  handleNumWashesChanged,
}: NucleofectionFooterProps) => {
  const disableUploadButton =
    nucPlateInfo.labwareTypeCode !== "" || selectedSystem === 0;
  const renderSourceToNucFooter = () => {
    return (
      <>
        <StyledPlateActions>
          <Button
            variant="outlined"
            onClick={() => handleUploadPlateClick(0)}
            disabled={disableUploadButton}
          >
            Upload Plate
          </Button>
          <Button
            variant="outlined"
            onClick={() =>
              handlePlateTypeChanged(0, nucPlateTypeInfo.nucPlateInfo[0])
            }
            disabled={
              nucPlateInfo.labwareTypeCode !== "" || selectedSystem === 0
            }
          >
            New Nuc Plate
          </Button>
          <Button
            variant="outlined"
            disabled={nucPlateInfo.labwareTypeCode === ""}
            onClick={() => setUploadedNucleofectionPlate(false)}
          >
            Remove Plate
          </Button>
        </StyledPlateActions>
        <StyledPlateTypeContainer>
          <PlateType
            platePosition={PlatePosition.Nucleofection}
            isDisabled={true}
            plateType={nucPlateInfo.labwareTypeCode}
            acceptedPlateTypes={nucPlateTypeInfo.nucPlateInfo}
          />
        </StyledPlateTypeContainer>
        <StyledButtonDiv>
          <Button
            variant="contained"
            onClick={handleAddToNucPlate}
            disabled={addToNucButtonDisabled}
            sx={{ marginTop: "10px", width: "50%" }}
          >
            Add Wells to Nuc Plate
          </Button>
        </StyledButtonDiv>
      </>
    );
  };

  const renderNucToIntFooter = () => {
    return (
      <>
        <StyledPlateTypeContainer>
          <PlateType
            platePosition={PlatePosition.Nucleofection}
            isDisabled={
              nucPlateInfo.labwareTypeCode !== "" || selectedSystem === 0
            }
            plateType={nucPlateInfo.labwareTypeCode}
            acceptedPlateTypes={nucPlateTypeInfo.nucPlateInfo}
            setPlateType={
              (plateTypeInfo) => handlePlateTypeChanged(0, plateTypeInfo) //Always 1 Nuc Plate
            }
          />
        </StyledPlateTypeContainer>
        <div>
          <NumberField
            style={{
              width: "32%",
              marginTop: "10px",
              marginRight: "5px",
            }}
            id="operating-vol"
            label="Operating Vol (µL)"
            value={nucPlateInfo.operatingVol}
            onChange={() => {
              return;
            }}
            disabled={true}
          />
          <NumberField
            style={{
              width: "32%",
              marginTop: "10px",
              marginRight: "5px",
            }}
            id="wash-cycles"
            label="Num Wash Cycles"
            value={nucPlateInfo.numberOfWashes}
            onChange={(value) => handleNumWashesChanged(0, parseInt(value))}
            minValue={0}
            maxValue={3}
            disabled={nucPlateInfo.rows.length === 0}
          />
          <WashVol nucPlateInfo={nucPlateInfo} width={32} />
        </div>
      </>
    );
  };

  switch (nucelofectionStep) {
    case NucleofectionStep.SelectSourceToNucleofection:
      return renderSourceToNucFooter();
    case NucleofectionStep.SelectNucleofectionToIntermediate:
      return renderNucToIntFooter();
    default:
      return null;
  }
};
